export default __webpack_public_path__ + "ad538a6207bdf5619ff0aae1528bd188.png";